exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NotifiableActionsForTvConsoles_emptyMessage_1nx4 {\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"emptyMessage": "NotifiableActionsForTvConsoles_emptyMessage_1nx4"
};